import { IBusinessGroup, IOrganization, templatesService } from "entities/template";
import React, {  useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export function useDocumentFormData() {
    const [organizations, setOrganizations] = useState<IOrganization[]>([]);
    const [businessGroups, setBusinessGroups] = useState<IBusinessGroup[]>([]);
    const { extUserId } = useParams();

    useEffect(() => {
        const promises = [templatesService.loadBusinessGroups(extUserId), templatesService.loadOrganizations(extUserId)]
        Promise.all(promises).then(([groups, organizations]) => {
            setBusinessGroups(groups as IBusinessGroup[]);
            setOrganizations(organizations as IOrganization[]);
        })
    }, []);

    return { organizations, businessGroups };
}
